(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vault-category-navigation"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    if (window.matchMedia('(min-width: 750px)').matches) return;

    const link = event.target.closest('a');
    if (!link) return;

    const label = link.textContent.trim().replace(/\s+/g, ' ').toUpperCase();
    if (label !== 'SHOP THE COLLECTION') return;

    const drawer = document.querySelector('#Details-menu-drawer-container');
    const trigger = drawer?.querySelector(':scope > summary.header__icon--menu');
    if (!drawer || !trigger) return;

    event.preventDefault();
    if (!drawer.open) trigger.click();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vault-daily-countdown"] && !Shopify.designMode) return;
  try {
    
  const vaultCountdownOffset = 4 * 60 * 60 * 1000;
  const vaultCountdownDay = 24 * 60 * 60 * 1000;
  const vaultCountdownHour = 60 * 60 * 1000;
  const vaultCountdownMinute = 60 * 1000;

  function vaultCountdownPad(value) {
    return String(value).padStart(2, '0');
  }

  function vaultCountdownUpdate(element) {
    const now = Date.now();
    const gulfNow = new Date(now + vaultCountdownOffset);
    const nextMidnight = Date.UTC(
      gulfNow.getUTCFullYear(),
      gulfNow.getUTCMonth(),
      gulfNow.getUTCDate() + 1
    ) - vaultCountdownOffset;
    const remaining = Math.max(0, nextMidnight - now);
    const days = Math.floor(remaining / vaultCountdownDay);
    const hours = Math.floor((remaining % vaultCountdownDay) / vaultCountdownHour);
    const minutes = Math.floor((remaining % vaultCountdownHour) / vaultCountdownMinute);
    const seconds = Math.floor((remaining % vaultCountdownMinute) / 1000);

    element.querySelector('[data-vd-days]').textContent = vaultCountdownPad(days);
    element.querySelector('[data-vd-hours]').textContent = vaultCountdownPad(hours);
    element.querySelector('[data-vd-minutes]').textContent = vaultCountdownPad(minutes);
    element.querySelector('[data-vd-seconds]').textContent = vaultCountdownPad(seconds);
  }

  function vaultCountdownUpdateAll() {
    document.querySelectorAll('[data-vd-countdown]').forEach(vaultCountdownUpdate);
  }

  vaultCountdownUpdateAll();
  window.setInterval(vaultCountdownUpdateAll, 1000);

  } catch(e) { console.error(e); }
})();
})();
